module.exports = __webpack_public_path__ + "img/watermark.f88dd029.jpg";